module.exports = __webpack_public_path__ + "img/logo_dty.d737a139.png";